<template>

    <div>
        <base_aggregator
            @edit_location="edit_location"
            @get_json="get_json"
            @show_menu="show_menu"
            @make_sync="make_sync"
            @add_location="add_location"
            @head_action="head_action"
            :provider_id=parseInt(this.provider_id)
            provider_type="delivero"
        />

        <delivero_location_modal></delivero_location_modal>
    </div>
</template>

<script>

import base_aggregator from "../base/base_aggregator";

import {mapGetters} from "vuex";
import delivero_location_modal from "./location/delivero_location_modal";

export default {
    name: "delivero_export",
    components: {delivero_location_modal, base_aggregator},
    props : {
        provider_id: {
            type: [Number, String],
            required: true,
        },
    },
    created() {
        EventBus.$on('loaded_api',this.load_provider);
        EventBus.$on('reload_provider',this.load_provider);

        if(window.hasOwnProperty('agr_api')) {
            this.load_provider();
        }
    },

    methods: {
        head_action() {

        },

        make_sync(location) {

        },

        show_menu(location) {
            window.open("/delivero/" + location.id + "/preview");
        },

        get_json(location) {
            window.open("/internal/delivero/restaurants/" + location.id + "/json");
        },


        edit_location(location) {
            EventBus.$emit("location_edit",{
                'org_id' : 0,
                'org_obj' : null,
                'location_id' : location.id,
                'provider_id' : this.provider_id
            });
        },

        add_location(organization) {

            EventBus.$emit("location_edit",{
                'org_id' : organization.id,
                'org_obj' : organization,
                'location_id' : 0,
                'provider_id' : this.provider_id
            });
        },

        load_provider() {
            this.$store.dispatch('aggregator/LOAD_OUT_PROVIDER',this.provider_id);
        }
    },

    computed : {

        ...mapGetters({
            'aggregator'        : "aggregator/getAggregator",
            'is_load_complete'  : "aggregator/is_load_complete"
        }),
    }
}
</script>

<style scoped>

</style>
